import React from 'react';
import PatientInfoSummary, { PatientInfoSummaryProps } from './PatientInfoSummary';
import ThemedComponent from '../../theme/ThemedComponent';

export function PatientInfoSummaryWrapper({
  alertService,
  patient,
  patientDisplayAge,
}: PatientInfoSummaryProps): React.JSX.Element {
  return (
    <ThemedComponent>
      <PatientInfoSummary alertService={alertService} patient={patient} patientDisplayAge={patientDisplayAge} />
    </ThemedComponent>
  );
}

export default PatientInfoSummaryWrapper;
